// extracted by mini-css-extract-plugin
export var bold = "legacy-phone-module--bold--54d74";
export var caption = "legacy-phone-module--caption--6b826";
export var ctaLarge = "legacy-phone-module--cta-large--9b8b8";
export var eyebrow = "legacy-phone-module--eyebrow--6f9ba";
export var h1 = "legacy-phone-module--h1--fab4e";
export var h1Large = "legacy-phone-module--h1--large--b5d34";
export var h2 = "legacy-phone-module--h2--def76";
export var h3 = "legacy-phone-module--h3--416f7";
export var h4 = "legacy-phone-module--h4--defeb";
export var h5 = "legacy-phone-module--h5--a3eaa";
export var h6 = "legacy-phone-module--h6--ee9ab";
export var italic = "legacy-phone-module--italic--fd679";
export var legacyPhoneDark = "legacy-phone-module--legacy-phone--dark--ebc86";
export var legacyPhoneError = "legacy-phone-module--legacy-phone--error--4becd";
export var legacyPhoneSuccess = "legacy-phone-module--legacy-phone--success--0ac1e";
export var legacyPhone__component = "legacy-phone-module--legacy-phone__component--6a73f";
export var legacyPhone__icon = "legacy-phone-module--legacy-phone__icon--6db82";
export var legacyPhone__wrapper = "legacy-phone-module--legacy-phone__wrapper--9727c";
export var mt0 = "legacy-phone-module--mt-0--31bae";
export var mt1 = "legacy-phone-module--mt-1--29bd7";
export var mt2 = "legacy-phone-module--mt-2--2a87d";
export var mt3 = "legacy-phone-module--mt-3--c909e";
export var mt4 = "legacy-phone-module--mt-4--fa1d4";
export var mt5 = "legacy-phone-module--mt-5--fa49d";
export var mt6 = "legacy-phone-module--mt-6--1f595";
export var p = "legacy-phone-module--p--b0152";
export var pSmall = "legacy-phone-module--p-small--664c3";
export var sideNavLabel = "legacy-phone-module--side-nav-label--5af16";
export var stat = "legacy-phone-module--stat--9ed3e";